import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
  

}
export class LicensePlateComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

   let field = this.props.field;
   FormValidationUtils.runJavascript(field);
  }

  valueLength(value) {
    if (typeof value == 'string') {
      return value.length;
    }
    return 0;
  }
  onChange = (e) => {
    let field = this.props.field;
    let val = e.target.value;
    field.Value = val;
    FormValidationUtils.validateLicensePlate(field, field.licensePlateType);
    FormValidationUtils.runJavascript(field);
    this.props.callbackElement(getRootComponent(this.props.field));
  }
  render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>

          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <div>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />

          </div>
          <div key={'fdIpt_div_' + field.Id} >
            <div>
              <input className={this.props.field.Valid ? 'ontario-input' : 'ontario-input ontario-input__error'} id={field.LoadBindName}  key={'fdIpt_' + field.Id}
                required={requiredField} value={field.Value} readOnly={field.ReadOnly}
                onBlur={() => this.setState({ touched: true })}
                onChange={this.onChange} 
                maxLength={field.maxLength}/>
            </div>
            {field.counterVisible  && <div className="word-count">{this.valueLength(field.Value) + "/" + field.Length}</div>}
          </div>
        </div>);
    } else {
      controlArray.push(
        <div className={classNames('pdf-two-column', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
          <div>{title}</div>
          <div> {field.Value}</div>
        </div>
      );
    }

    return controlArray;

  }

}